import { Button, Col, Form, Row } from "react-bootstrap";
import Card from "../../../../../components/bootstrap/card";
import CommaFormattedInput from "../../../../../components/form/CommaFormattedInput";

const InstructorWageGroupForm = ({ 
  formData, groupLessonDiscountPrice, handleLessnDataChange, groupLessonCounts, groupOptionCounts
}) => (
  <Card>
    <Card.Header className="d-flex justify-content-between">
      <div className="header-title">
        <h4 className="card-title">그룹레슨</h4>
      </div>
    </Card.Header>
    <Card.Body>
      <div className="new-user-info">
        <div className="row">
          <Form.Group className="col-md-12 form-group">
            <Form.Label htmlFor="fname">금액 합계</Form.Label>
            <CommaFormattedInput
              name="groupPrice"
              value={formData.groupPrice}
              onChange={handleLessnDataChange}
              disabled={true}
            />
          </Form.Group>
          {/* <Form.Group className="col-md-6 form-group">
            <Form.Label htmlFor="fname">참여인원</Form.Label>
            <Form.Control
              type="number"
              name="groupCount"
              value={formData.groupCount}
              onChange={handleLessnDataChange}
              disabled={true}
            />
          </Form.Group>
          <Form.Group className="col-md-6 form-group">
            <Form.Label htmlFor="fname">운용레슨수</Form.Label>
            <Form.Control
              type="number"
              name="groupLessonCount"
              value={formData.groupLessonCount}
              onChange={handleLessnDataChange}
              disabled={true}
              required
            />
          </Form.Group> */}
        </div>
        <div className="row mt-2">
          <div className="col-md-12">
            <Form.Label className="fw-bold mb-2">참여인원</Form.Label>
            <div>
              {groupLessonCounts && Object.keys(groupLessonCounts).length > 0 ? (
                Object.entries(groupLessonCounts).map(([date, info]) => (
                  <div key={date} className="bg-light rounded px-2 py-2 mb-2 border w-100">
                    <div className="fw-semibold text-dark mb-1 text-break" style={{ minWidth: 120 }}>{date}</div>
                    <div className="d-flex flex-wrap align-items-center gap-2 mb-1">
                      <span className="badge bg-primary me-1">참여</span>
                      {info.reserves && info.reserves.length > 0 ? (
                        info.reserves.map((name, idx) => (
                          <span key={name + idx} className="badge bg-primary-subtle text-primary border border-primary-subtle">{name}</span>
                        ))
                      ) : (
                        <span className="badge bg-secondary">-</span>
                      )}
                    </div>
                    {info.noshows && info.noshows.length > 0 && (
                      <div className="d-flex flex-wrap align-items-center gap-2 mb-1">
                        <span className="badge bg-danger me-1">노쇼</span>
                        {info.noshows.map((name, idx) => (
                          <span key={name + idx} className="badge bg-danger-subtle text-danger border border-danger-subtle">{name}</span>
                        ))}
                      </div>
                    )}
                    <div className="d-flex align-items-center gap-2">
                      <span className="badge bg-success">총원 {info.total}</span>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center text-muted py-1">데이터 없음</div>
              )}
            </div>
            <Form.Label className="fw-bold mt-3 mb-2">운용레슨수</Form.Label>
            <div>
              {groupOptionCounts && Object.entries(groupOptionCounts).map(([key, value]) => (
                <div key={key} className="d-flex align-items-center justify-content-between bg-light rounded px-2 py-1 mb-1 border w-100">
                  <span className="fw-semibold text-dark">{key}</span>
                  <span className="badge bg-secondary fs-6">{value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Card.Body>
  </Card>
);

export default InstructorWageGroupForm;
